import { styled, TextField } from "@mui/material";

const StyledTextField = styled(TextField)(({ theme }) => ({
    "& .css-1x51dt5-MuiInputBase-input-MuiInput-input.Mui-disabled": {
        WebkitTextFillColor: theme.palette.text.disabled,
        color: theme.palette.text.disabled
    },
    "& .MuiInput-root.Mui-disabled::before": {
        borderBottomStyle: "solid",
        borderBottomColor: theme.palette.text.disabled,
        borderBottomWidth: 1
    },
    "&& .MuiInput-root.Mui-disabled:hover::before": {
        borderColor: theme.palette.text.disabled
    },
    "& .MuiFormLabel-root.Mui-focused": {
        color: theme.palette.text.primary
    },
    "& .MuiFormLabel-root.Mui-disabled": {
        color: theme.palette.text.disabled
    },
    "& .disabled": {
        color: theme.palette.action.hover
    },
    "&& .MuiInput-root:hover::before": {
        borderColor: theme.palette.text.disabled
    }
}));

export default StyledTextField;